import React from "react";
import Arrow from "@/src/icons/Arrow";

const CarouselArrow = ({
  direction,
  position,
  customClass,
}: {
  position: "next" | "prev";
  direction?: "up" | "down" | "left" | "right";
  customClass?: string;
}) => {
  return (
    <button
      className={`absolute z-20 ${customClass} ${
        position === "prev" ? "left-1 sm:left-2 md:left-4" : "right-1 sm:right-2 md:right-4"
      } top-1/2 transform -translate-y-1/2`}
    >
      <Arrow direction={direction} fill={"#1E1E1E"} />
    </button>
  );
};

export default CarouselArrow;
